// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const content: Styleguide["content"] = {
    isFullWidth: true,
};

export default content;
